"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.listApps = exports.streamAppInstall = exports.execWithTransport = void 0;
var devices_1 = require("@ledgerhq/devices");
var errors_1 = require("@ledgerhq/errors");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var manager_1 = require("../types/manager");
var manager_2 = __importStar(require("../manager"));
var installApp_1 = __importDefault(require("../hw/installApp"));
var uninstallApp_1 = __importDefault(require("../hw/uninstallApp"));
var logs_1 = require("@ledgerhq/logs");
var getDeviceInfo_1 = __importDefault(require("../hw/getDeviceInfo"));
var currencies_1 = require("../currencies");
var Manager_1 = __importDefault(require("../api/Manager"));
var env_1 = require("../env");
var listApps_1 = __importDefault(require("../hw/listApps"));
var polyfill_1 = require("./polyfill");
var logic_1 = require("../apps/logic");
var runner_1 = require("../apps/runner");
var execWithTransport = function (transport) {
    return function (appOp, targetId, app) {
        var fn = appOp.type === "install" ? installApp_1["default"] : uninstallApp_1["default"];
        return fn(transport, targetId, app);
    };
};
exports.execWithTransport = execWithTransport;
var appsThatKeepChangingHashes = ["Fido U2F"];
// global percentage
var streamAppInstall = function (_a) {
    var transport = _a.transport, appNames = _a.appNames, onSuccessObs = _a.onSuccessObs;
    return (0, rxjs_1.concat)((0, rxjs_1.of)({
        type: "listing-apps"
    }), (0, rxjs_1.from)((0, getDeviceInfo_1["default"])(transport)).pipe((0, operators_1.mergeMap)(function (deviceInfo) { return (0, exports.listApps)(transport, deviceInfo); }), (0, operators_1.mergeMap)(function (e) {
        if (e.type === "device-permission-granted" ||
            e.type === "device-permission-requested") {
            // pass in events we need
            return (0, rxjs_1.of)(e);
        }
        if (e.type === "result") {
            // stream install with the result of list apps
            var state = appNames.reduce(function (state, name) {
                return (0, logic_1.reducer)(state, {
                    type: "install",
                    name: name
                });
            }, (0, logic_1.initState)(e.result));
            if (!state.installQueue.length) {
                return (0, rxjs_1.defer)(onSuccessObs || (function () { return rxjs_1.EMPTY; }));
            }
            if ((0, logic_1.isOutOfMemoryState)((0, logic_1.predictOptimisticState)(state))) {
                // In this case we can't install either by lack of storage, or permissions,
                // we fallback to the error case listing the missing apps.
                var missingAppNames = state.installQueue;
                return (0, rxjs_1.of)({
                    type: "app-not-installed",
                    appNames: missingAppNames,
                    appName: missingAppNames[0] || appNames[0]
                });
            }
            var exec = (0, exports.execWithTransport)(transport);
            return (0, rxjs_1.concat)((0, runner_1.runAllWithProgress)(state, exec).pipe((0, operators_1.map)(function (progress) { return ({
                type: "stream-install",
                progress: progress
            }); })), (0, rxjs_1.defer)(onSuccessObs || (function () { return rxjs_1.EMPTY; })));
        }
        return rxjs_1.EMPTY;
    })));
};
exports.streamAppInstall = streamAppInstall;
var listApps = function (transport, deviceInfo) {
    var _a;
    if (deviceInfo.isOSU || deviceInfo.isBootloader) {
        return (0, rxjs_1.throwError)(new errors_1.UnexpectedBootloader(""));
    }
    var deviceModelId = (transport.deviceModel && transport.deviceModel.id) ||
        ((_a = (deviceInfo && (0, devices_1.identifyTargetId)(deviceInfo.targetId))) === null || _a === void 0 ? void 0 : _a.id) ||
        (0, env_1.getEnv)("DEVICE_PROXY_MODEL");
    return new rxjs_1.Observable(function (o) {
        var sub;
        function main() {
            return __awaiter(this, void 0, void 0, function () {
                var installedP, provider, deviceVersionP, firmwareDataP, latestFirmwareForDeviceP, firmwareP, applicationsByDeviceP, _a, _b, partialInstalledList, installedAvailable, applicationsList, compatibleAppVersionsList, firmware, sortedCryptoCurrencies, installedList, shouldCompleteInstalledList, apps, deviceModel, appByName, installed, appsListNames, result;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            installedP = new Promise(function (resolve, reject) {
                                sub = Manager_1["default"].listInstalledApps(transport, {
                                    targetId: deviceInfo.targetId,
                                    perso: "perso_11"
                                }).subscribe({
                                    next: function (e) {
                                        if (e.type === "result") {
                                            resolve(e.payload);
                                        }
                                        else if (e.type === "device-permission-granted" ||
                                            e.type === "device-permission-requested") {
                                            o.next(e);
                                        }
                                    },
                                    error: reject
                                });
                            })
                                .then(function (apps) {
                                return apps.map(function (_a) {
                                    var name = _a.name, hash = _a.hash;
                                    return ({
                                        name: name,
                                        hash: hash,
                                        blocks: 0
                                    });
                                });
                            })["catch"](function (e) {
                                (0, logs_1.log)("hw", "failed to HSM list apps " + String(e) + "\n" + e.stack);
                                if ((0, env_1.getEnv)("EXPERIMENTAL_FALLBACK_APDU_LISTAPPS")) {
                                    return (0, listApps_1["default"])(transport)
                                        .then(function (apps) {
                                        return apps.map(function (_a) {
                                            var name = _a.name, hash = _a.hash, blocks = _a.blocks;
                                            return ({
                                                name: name,
                                                hash: hash,
                                                blocks: blocks
                                            });
                                        });
                                    })["catch"](function (e) {
                                        (0, logs_1.log)("hw", "failed to device list apps " + String(e) + "\n" + e.stack);
                                        throw e;
                                    });
                                }
                                else {
                                    throw e;
                                }
                            })
                                .then(function (apps) { return [apps, true]; });
                            provider = (0, manager_2.getProviderId)(deviceInfo);
                            deviceVersionP = Manager_1["default"].getDeviceVersion(deviceInfo.targetId, provider);
                            firmwareDataP = deviceVersionP.then(function (deviceVersion) {
                                return Manager_1["default"].getCurrentFirmware({
                                    deviceId: deviceVersion.id,
                                    version: deviceInfo.version,
                                    provider: provider
                                });
                            });
                            latestFirmwareForDeviceP = manager_2["default"].getLatestFirmwareForDevice(deviceInfo);
                            firmwareP = Promise.all([
                                firmwareDataP,
                                latestFirmwareForDeviceP,
                            ]).then(function (_a) {
                                var _b = __read(_a, 2), firmwareData = _b[0], updateAvailable = _b[1];
                                return (__assign(__assign({}, firmwareData), { updateAvailable: updateAvailable }));
                            });
                            applicationsByDeviceP = Promise.all([
                                deviceVersionP,
                                firmwareDataP,
                            ]).then(function (_a) {
                                var _b = __read(_a, 2), deviceVersion = _b[0], firmwareData = _b[1];
                                return Manager_1["default"].applicationsByDevice({
                                    provider: provider,
                                    current_se_firmware_final_version: firmwareData.id,
                                    device_version: deviceVersion.id
                                });
                            });
                            return [4 /*yield*/, Promise.all([
                                    installedP,
                                    Manager_1["default"].listApps().then(function (apps) { return apps.map(polyfill_1.polyfillApplication); }),
                                    applicationsByDeviceP,
                                    firmwareP,
                                    (0, currencies_1.currenciesByMarketcap)((0, currencies_1.listCryptoCurrencies)((0, env_1.getEnv)("MANAGER_DEV_MODE"), true)),
                                ])];
                        case 1:
                            _a = __read.apply(void 0, [_c.sent(), 5]), _b = __read(_a[0], 2), partialInstalledList = _b[0], installedAvailable = _b[1], applicationsList = _a[1], compatibleAppVersionsList = _a[2], firmware = _a[3], sortedCryptoCurrencies = _a[4];
                            installedList = partialInstalledList;
                            shouldCompleteInstalledList = partialInstalledList.some(function (a) { return !a.name; });
                            if (shouldCompleteInstalledList) {
                                installedList = installedList.map(function (a) {
                                    if (a.name)
                                        return a; // already present
                                    var application = applicationsList.find(function (e) {
                                        return e.application_versions.some(function (v) { return v.hash === a.hash; });
                                    });
                                    if (!application)
                                        return a; // still no luck with our api
                                    return __assign(__assign({}, a), { name: application.name });
                                });
                            }
                            apps = compatibleAppVersionsList
                                .map(function (version) {
                                var application = applicationsList.find(function (e) { return e.id === version.app; });
                                if (!application)
                                    return;
                                var isDevTools = application.category === 2;
                                var currencyId = application.currencyId;
                                var crypto = currencyId && (0, currencies_1.findCryptoCurrencyById)(currencyId);
                                if (!crypto) {
                                    currencyId = undefined;
                                }
                                var indexOfMarketCap = crypto
                                    ? sortedCryptoCurrencies.indexOf(crypto)
                                    : -1;
                                var compatibleWallets = [];
                                if (application.compatibleWalletsJSON) {
                                    try {
                                        var parsed = JSON.parse(application.compatibleWalletsJSON);
                                        if (parsed && Array.isArray(parsed)) {
                                            parsed.forEach(function (w) {
                                                if (w && typeof w === "object" && w.name) {
                                                    compatibleWallets.push({
                                                        name: w.name,
                                                        url: w.url
                                                    });
                                                }
                                            });
                                        }
                                    }
                                    catch (e) {
                                        console.error("invalid compatibleWalletsJSON for " + version.name, e);
                                    }
                                }
                                var type = application.description &&
                                    Object.values(manager_1.AppType).includes(application.description)
                                    ? manager_1.AppType[application.description]
                                    : manager_1.AppType.app;
                                var app = (0, polyfill_1.polyfillApp)({
                                    id: version.id,
                                    name: version.name,
                                    displayName: version.display_name,
                                    version: version.version,
                                    currencyId: currencyId,
                                    description: version.description,
                                    type: type,
                                    dateModified: version.date_last_modified,
                                    icon: version.icon,
                                    authorName: application.authorName,
                                    supportURL: application.supportURL,
                                    contactURL: application.contactURL,
                                    sourceURL: application.sourceURL,
                                    compatibleWallets: compatibleWallets,
                                    hash: version.hash,
                                    perso: version.perso,
                                    firmware: version.firmware,
                                    firmware_key: version.firmware_key,
                                    "delete": version["delete"],
                                    delete_key: version.delete_key,
                                    dependencies: [],
                                    bytes: version.bytes,
                                    warning: version.warning,
                                    indexOfMarketCap: indexOfMarketCap,
                                    isDevTools: isDevTools
                                });
                                return app;
                            })
                                .filter(Boolean);
                            (0, logs_1.log)("list-apps", "".concat(installedList.length, " apps installed. ").concat(applicationsList.length, " apps store total. ").concat(apps.length, " available."), {
                                installedList: installedList
                            });
                            deviceModel = (0, devices_1.getDeviceModel)(deviceModelId);
                            appByName = {};
                            apps.forEach(function (app) {
                                if (app)
                                    appByName[app.name] = app;
                            });
                            installed = installedList.map(function (_a) {
                                var name = _a.name, hash = _a.hash, blocks = _a.blocks;
                                var app = applicationsList.find(function (a) { return a.name === name; });
                                var installedAppVersion = app && hash
                                    ? app.application_versions.find(function (v) { return v.hash === hash; })
                                    : null;
                                var availableAppVersion = appByName[name];
                                var blocksSize = blocks ||
                                    Math.ceil(((installedAppVersion ||
                                        availableAppVersion || {
                                        bytes: 0
                                    }).bytes || 0) / deviceModel.getBlockSize(deviceInfo.version));
                                var updated = appsThatKeepChangingHashes.includes(name) ||
                                    (availableAppVersion ? availableAppVersion.hash === hash : false);
                                var version = installedAppVersion ? installedAppVersion.version : "";
                                var availableVersion = availableAppVersion
                                    ? availableAppVersion.version
                                    : "";
                                return {
                                    name: name,
                                    updated: updated,
                                    blocks: blocksSize,
                                    hash: hash,
                                    version: version,
                                    availableVersion: availableVersion
                                };
                            });
                            appsListNames = ((0, env_1.getEnv)("MANAGER_DEV_MODE")
                                ? apps
                                : apps.filter(function (a) {
                                    return !(a === null || a === void 0 ? void 0 : a.isDevTools) || installed.some(function (_a) {
                                        var name = _a.name;
                                        return name === a.name;
                                    });
                                }))
                                .map(function (a) { var _a; return (_a = a === null || a === void 0 ? void 0 : a.name) !== null && _a !== void 0 ? _a : ""; })
                                .filter(Boolean);
                            result = {
                                appByName: appByName,
                                appsListNames: appsListNames,
                                installed: installed,
                                installedAvailable: installedAvailable,
                                deviceInfo: deviceInfo,
                                deviceModelId: deviceModelId,
                                firmware: firmware
                            };
                            o.next({
                                type: "result",
                                result: result
                            });
                            return [2 /*return*/];
                    }
                });
            });
        }
        main().then(function () {
            o.complete();
        }, function (e) {
            o.error(e);
        });
        return function () {
            if (sub)
                sub.unsubscribe();
        };
    });
};
exports.listApps = listApps;
//# sourceMappingURL=hw.js.map